// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__1fY1_","inputWrap":"CustomTip_inputWrap__1K91H"};